export default {
  "l10n": {
    "date": {
      "months": {
        "full": ["enero","febrero","marzo","abril","mayo","junio","julio","agosto","septiembre","octubre","noviembre","diciembre"],
        "abbr": ["ene.","feb.","mar.","abr.","may.","jun.","jul.","ago.","sep.","oct.","nov.","dic."]
      },
      "days": {
        "full": ["domingo","lunes","martes","miércoles","jueves","viernes","sábado"],
        "abbr": ["do.","lu.","ma.","mi.","ju.","vi.","sá."]
      },
      "patterns": {
        "longtime": "HH:mm:ss",
        "birthdate": "dd/MM/yyyy",
        "shorttime": "HH:mm",
        "shortdate": "dd/MM HH:mm",
        "shortday": "dd MMM",
        "fulldate": "dd/MM/yyyy HH:mm"
      }
    },
    "number": {
      "patterns": {
        "standard": ["-n", "n"],
        "amount": ["-n S", "n S"],
        "blinds": "s-b S"
      },
      "group": {
        "separator": ".",
        "length": 3,
        "abbr": ["", "k", "M", "B"]
      },
      "decimal": {
        "separator": ",",
        "length": 2
      },
      "ordinal": function(number) { return number + (number === 1 ? '°' : '°'); }
    }
  },
  "translations": {
    "messages": {
  "Challenges": [
    null,
    "Challenges"
  ],
  "Close": [
    null,
    "Cerrar"
  ],
  "Guarantee": [
    null,
    "Garantizado"
  ],
  "Name": [
    null,
    "Nombre"
  ],
  "Next level": [
    null,
    "Siguiente nivel"
  ],
  "No data": [
    null,
    "Sin datos"
  ],
  "Points": [
    null,
    "Puntos"
  ],
  "Potential winnings": [
    null,
    "Ganancias potenciales"
  ],
  "Rank": [
    null,
    "Posición"
  ],
  "to be shared out every day!": [
    null,
    "en juego cada día!"
  ]
}
  }
}
